var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 2.22223H1.77777C1.54203 2.22223 1.31593 2.31588 1.14923 2.48258C0.982536 2.64928 0.888885 2.87537 0.888885 3.11112V12.8889C0.888885 13.1246 0.982536 13.3507 1.14923 13.5174C1.31593 13.6841 1.54203 13.7778 1.77777 13.7778H14.2222C14.458 13.7778 14.6841 13.6841 14.8508 13.5174C15.0175 13.3507 15.1111 13.1246 15.1111 12.8889V3.11112C15.1111 2.87537 15.0175 2.64928 14.8508 2.48258C14.6841 2.31588 14.458 2.22223 14.2222 2.22223V2.22223ZM1.77777 12.8889V3.11112H14.2222V12.8889H1.77777Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94222 6.76531L4.26756 10.6524L2.46667 9.05953L2.93778 8.52709L4.13689 9.58753L6.94844 5.5022L9.94844 9.95331L12.9502 5.98664L13.5173 6.41597L9.91467 11.1755L6.94222 6.76531Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavReports);
export default __webpack_public_path__ + "static/media/nav_reports.9ce43681.svg";
export { ForwardRef as ReactComponent };